import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { User } from './types/User';
import { APIV2_URL } from './constants';

interface UserApiV2Response {
  users: User[];
}

const getUsers = (makeCall: MakeCall) => (uuids: string[]) =>
  makeCall<UserApiV2Response>('POST', `${APIV2_URL}/users`, {
    data: { uuids },
  });

export default getUsers;
